<rask-button class="arboreal-gradient" (click)="getArboreal()">
  Hämta data från Arboreal
</rask-button>

@if (model?.arborealBeraknadTid) {
  <div>
    <rask-label size="12" aid="arboreal-senasthamtad">
      Senast hämtad: {{$safeNavigationMigration(model?.arborealBeraknadTid) | date: "YYYY-MM-dd HH:mm:ss"}}
    </rask-label>
  </div>
}
